"use strict";

var _jsxRuntime = require("react/jsx-runtime");
module.exports = ({
  title,
  titleId,
  size,
  color,
  ...props
}) => /*#__PURE__*/(0, _jsxRuntime.jsxs)("svg", {
  ...props,
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24",
  height: size,
  width: size,
  fill: color,
  role: title ? 'img' : undefined,
  "aria-hidden": !title,
  "aria-labelledby": titleId,
  children: [title ? /*#__PURE__*/(0, _jsxRuntime.jsx)("title", {
    id: titleId,
    children: title
  }) : null, /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
    fillRule: "evenodd",
    d: "M13.5 14.5c1.93 0 3.5 1.57 3.5 3.5a3.504 3.504 0 0 1-3.308 3.495l-.192.005h-.793l.647.646a.503.503 0 0 1 0 .708.502.502 0 0 1-.629.064l-.079-.064-1.5-1.5c-.022-.022-.032-.049-.049-.075-.02-.028-.044-.053-.058-.087a.498.498 0 0 1 0-.383l.042-.078.065-.085 1.5-1.5a.503.503 0 0 1 .708 0 .504.504 0 0 1 .058.639l-.058.069-.647.646h.793c1.378 0 2.5-1.122 2.5-2.5s-1.122-2.5-2.5-2.5a.5.5 0 0 1 0-1Zm-3.852-1.354a.502.502 0 0 1 .637-.057l.07.057 1.5 1.5.009.015c.04.044.075.093.098.147a.501.501 0 0 1 0 .384c-.014.033-.038.06-.058.087l-.023.039-.026.035-1.5 1.5a.5.5 0 0 1-.766-.637l.058-.07.647-.646H9.5A2.503 2.503 0 0 0 7 18c0 1.378 1.122 2.5 2.5 2.5a.5.5 0 1 1 0 1C7.57 21.5 6 19.93 6 18a3.504 3.504 0 0 1 3.308-3.495L9.5 14.5h.793l-.646-.647a.5.5 0 0 1 0-.707ZM11.5 1c3.566 0 6.652 2.56 7.346 6.023C21.758 7.232 24 9.609 24 12.5c0 3.033-2.466 5.5-5.5 5.5a.5.5 0 0 1 0-1c2.482 0 4.5-2.02 4.5-4.5 0-2.481-2.018-4.5-4.5-4.5-.277-.027-.538-.171-.573-.422C17.474 4.398 14.711 2 11.5 2A6.508 6.508 0 0 0 5 8.5c0 .28.024.578.076.938a.5.5 0 0 1-.12.402c-.098.109-.256.156-.383.169l-.073-.006A.604.604 0 0 1 4.467 10C2.57 9.999 1 11.569 1 13.499S2.57 17 4.5 17a.5.5 0 0 1 0 1A4.505 4.505 0 0 1 0 13.5a4.507 4.507 0 0 1 4.022-4.474A6.391 6.391 0 0 1 4 8.5C4 4.364 7.365 1 11.5 1Z",
    clipRule: "evenodd"
  })]
});